module.exports = __webpack_public_path__ + "img/9.05ce62fe.png";